import { device, onPageVisibility } from "wnl-xdsdk";
import { getWxParamse, checkVersion } from "../api/index";
// import wxSdk from 'weixin-js-sdk'

function open (url) {
    let a = document.createElement("a");
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
let seFtTime = null;
export const useOpenApp = (url, urlLink = "") => {
    const { isAndroid, isWx, isIos } = device;
    if (isAndroid) {
        if (!isWx) {
            window.location.href = url;
            let last = Date.now();
            seFtTime = setTimeout(() => {
                let hidden =
                    window.document.hidden ||
                    window.document.mozHidden ||
                    window.document.msHidden ||
                    window.document.webkitHidden;
                if (
                    Date.now() - last < 3300 &&
                    (typeof hidden == "undefined" || hidden == false)
                ) {
                    window.location.href = urlLink;
                }
            }, 3000);
            let remove = onPageVisibility(
                () => { },
                () => {
                    seFtTime && clearTimeout(seFtTime);
                    remove();
                }
            );
        }
    } else if (isIos) {
        if (isWx) {
            console.log(url);
            open(url);
        } else {
            open(url);
            let last = Date.now();
            seFtTime = setTimeout(() => {
                let hidden =
                    window.document.hidden ||
                    window.document.mozHidden ||
                    window.document.msHidden ||
                    window.document.webkitHidden;
                if (
                    Date.now() - last < 3300 &&
                    (typeof hidden == "undefined" || hidden == false)
                ) {
                    window.location.href =
                        "itms-apps://itunes.apple.com/app/id1534020402";
                }
            }, 3000);
            let remove = onPageVisibility(
                () => { },
                () => {
                    if (seFtTime) {
                        clearTimeout(seFtTime);
                        seFtTime = null;
                    }
                    remove();
                }
            );
        }
    }
};

export const useInitSDK = async () => {
    let url = window.location.href;
    const res = await getWxParamse({ url });
    if (res.status === 200) {
        const { appid, timestamp, noncestr, signature } = res.data;
        wx.config({
            debug: process.env.NODE_ENV !== 'production', // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: appid, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: signature, // 必填，签名
            jsApiList: ["onMenuShareAppMessage", "openLocation"], // 必填，需要使用的JS接口列表
            openTagList: ["wx-open-launch-app"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        });
        // wx.ready(() => {
        //     console.log("ready");
        // });
        // wx.launch((e) => {
        //     const { appId, extInfo } = e;
        //     console.log('launch', appId, extInfo);
        // })
        // wx.error((e) => {
        //     const { errMsg, appId, extInfo } = e
        //     console.log('error', errMsg, appId, extInfo);
        // });
    }
};

export const useCheckVersion = async () => {
    let res = await checkVersion();
    if (res.status === 200) {
        return res.data.url;
    }
    return "https://qiniu.other.cq-wnl.com/publish-normal64-2.2.5-2020050.apk";
};
